/* Publish by EComposer at 2026-10-15 13:07:46*/
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-34bary6c9qj"]=  window.__ectimmers["ecom-34bary6c9qj"] || {};
if(!this.$el)return;const t=this.$el,e=t.querySelector(".ecom-text_view-more-btn"),i=t.querySelector(".ecom-text_view-less-btn"),s=t.querySelector(".text-content.ecom-html");!s||(e&&e.addEventListener("click",()=>{s.classList.remove("ecom-text--is-mark"),s.style.maxHeight="",e.style.display="none",i.style.display=""}),i&&i.addEventListener("click",()=>{s.classList.add("ecom-text--is-mark"),s.style.maxHeight="var(--ecom-text-height)",i.style.display="none",e.style.display=""}))

                    });
                    
                        document.querySelectorAll('.ecom-34bary6c9qj').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-34bary6c9qj', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-fghu0zvs82').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-fghu0zvs82', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ebmxgte8ws').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ebmxgte8ws', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-0r27ofh59ujb').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-0r27ofh59ujb', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-cynykzefmc4').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-cynykzefmc4', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-2pzoace8d8d').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-2pzoace8d8d', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-hm3qxw09kvd').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-hm3qxw09kvd', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-503bpg2uy2c').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-503bpg2uy2c', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-pya8jomoz2').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-pya8jomoz2', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-kwmqkez3zug').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-kwmqkez3zug', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-775hh6l5r56').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-775hh6l5r56', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-udb4pco5q7k').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-udb4pco5q7k', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-4odmp3bcrm9').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-4odmp3bcrm9', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-0zrnmj7ib64d').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-0zrnmj7ib64d', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-mathoev018e').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-mathoev018e', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ye8bve5k87').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ye8bve5k87', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-4in387opvaf').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-4in387opvaf', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-i3pg8dmyv').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-i3pg8dmyv', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-jsmlhn2usy8').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-jsmlhn2usy8', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-86vc3puj4li').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-86vc3puj4li', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-yq9b9rplc9').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-yq9b9rplc9', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-vrl23u4rugc').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-vrl23u4rugc', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-pdqt5mvv2r').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-pdqt5mvv2r', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-nu772e3y90s').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-nu772e3y90s', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-88bhzdw84r9').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-88bhzdw84r9', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ghpy4qihfw9').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ghpy4qihfw9', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-s68x9h9hhc').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-s68x9h9hhc', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-s7w0ayjdeoe').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-s7w0ayjdeoe', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-5pab70zq2t').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-5pab70zq2t', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-8t0kpa5wyzc').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-8t0kpa5wyzc', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-jqi6i73xckn').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-jqi6i73xckn', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-tn3zkp079cq').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-tn3zkp079cq', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-cqh1jzqsx99').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-cqh1jzqsx99', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-bs3lx5x8kt').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-bs3lx5x8kt', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-q27i37m4rkn').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-q27i37m4rkn', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-uus50wgrt9').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-uus50wgrt9', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-t5ko4mfa51').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-t5ko4mfa51', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-9xveyt4ueva').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-9xveyt4ueva', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-s5qltijx9h').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-s5qltijx9h', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-l70qrdj25n').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-l70qrdj25n', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-gd4fzsa6bo6').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-gd4fzsa6bo6', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-1wqmszw1yyt').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-1wqmszw1yyt', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-xwsk5q5j2td').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-xwsk5q5j2td', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ieurc3379uj').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ieurc3379uj', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-aj9957q4yqu').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-aj9957q4yqu', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-p63yuv8to1').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-p63yuv8to1', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-my3l2kd12jg').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-my3l2kd12jg', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-7n77vas19v5').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-7n77vas19v5', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-0db4hntrifyt').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-0db4hntrifyt', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-llzsfz99bi').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-llzsfz99bi', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-p3xfgjvw6w').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-p3xfgjvw6w', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-yntcjg3hzlc').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-yntcjg3hzlc', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-k4392wfuixd').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-k4392wfuixd', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-qtuce6onca').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-qtuce6onca', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-fbb23lva7u').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-fbb23lva7u', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-a9mpdicefw').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-a9mpdicefw', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-9fhddz7fbmf').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-9fhddz7fbmf', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-eivz8t06hmb').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-eivz8t06hmb', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-o4d6ew1o5el').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-o4d6ew1o5el', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-s4tgeub3f98').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-s4tgeub3f98', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-0hgkfxru1z8q').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-0hgkfxru1z8q', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ckvh78ty0ce').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ckvh78ty0ce', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-03xvijkgbxc9').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-03xvijkgbxc9', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-qe1enrioa6').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-qe1enrioa6', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-g7kocehlepl').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-g7kocehlepl', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-wt77itsv2t8').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-wt77itsv2t8', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-95n4e0di41').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-95n4e0di41', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-msuxw68hmyp').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-msuxw68hmyp', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-kfhgxv084gj').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-kfhgxv084gj', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-2jav8lnynkm').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-2jav8lnynkm', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-xlzei6nflsr').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-xlzei6nflsr', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ctgsppqk5jn').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ctgsppqk5jn', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-eenih837945').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-eenih837945', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-d8p623nwcb').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-d8p623nwcb', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-o9zyf7vcljf').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-o9zyf7vcljf', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-7rda1sij5u5').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-7rda1sij5u5', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ov968wp74hh').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ov968wp74hh', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-hhw2ki0dzi9').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-hhw2ki0dzi9', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-2mp2ar12xhk').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-2mp2ar12xhk', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-m0d5iz6bfjn').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-m0d5iz6bfjn', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-k26wwtxykoj').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-k26wwtxykoj', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-a6x8y03xtj5').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-a6x8y03xtj5', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-n45gsne1khr').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-n45gsne1khr', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ksvs6v3aale').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ksvs6v3aale', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-umah4ay5a4j').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-umah4ay5a4j', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-99ipxozspm').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-99ipxozspm', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-270a5rr5ajn').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-270a5rr5ajn', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-0hqezu6dtqke').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-0hqezu6dtqke', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-34it9rdmeum').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-34it9rdmeum', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ivaiave23ig').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ivaiave23ig', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-t1zeaaxm3t').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-t1zeaaxm3t', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ihx69btr0t').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ihx69btr0t', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-e5e9sky062u').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-e5e9sky062u', settings: {},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-iafdmtqbgzp"]=  window.__ectimmers["ecom-iafdmtqbgzp"] || {};
if(!this.$el)return!1;const t=this.$el;this.settings.animation&&function(i){if(!t)return;const s=t.querySelector(".ecom__element--button");if(!s)return;let o=parseInt(i.settings.animation_loop_time)*1e3||6e3,n=1e3;window.__ectimmers["ecom-iafdmtqbgzp"]["0m2b3bw95"] = setInterval(function(){s.classList.add("animated"),setTimeout(function(){s.classList.remove("animated")},n)},o)}(this);var e=t.querySelector(".ecom__element--button");this.isLive&&e&&e.dataset.ecTrackingId&&e.addEventListener("click",function(i){if(window.Shopify&&window.Shopify.analytics){i.preventDefault();let s=window.EComposer.PAGE||window.EComposer.TEMPLATE||window.EComposer.SECTION||window.EComposer.BLOCK||{};const o=Object.assign({button_id:e.id,tracking_id:e.dataset.ecTrackingId},s);try{Shopify.analytics.publish("ec_custom_events",o)}catch(a){console.error("[EC Tracking] Error publishing analytics event:",a)}const n=e.getAttribute("href"),r=e.getAttribute("target");n&&n!=="#"&&n!=="javascript:void(0)"&&(r==="_blank"?window.open(n,"_blank"):setTimeout(function(){window.location.href=n},300))}},{once:!0}),this.isLive&&e&&e.dataset.eventTrackingFb&&e.addEventListener("click",function(i){window.fbq&&window.fbq("track",`${e.dataset.eventTrackingFb}`)},{once:!0})

                    });
                    
                        document.querySelectorAll('.ecom-iafdmtqbgzp').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-iafdmtqbgzp', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-xyy77lfbwgo').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-xyy77lfbwgo', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-l11olsj6dsj').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-l11olsj6dsj', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-sycuilgtstb').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-sycuilgtstb', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-aduoonhdnrg').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-aduoonhdnrg', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-0070maqkgdqao').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-0070maqkgdqao', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-jr3yakjjdq').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-jr3yakjjdq', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-7noslccslmh').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-7noslccslmh', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-gksiu5j1auk').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-gksiu5j1auk', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-zxoz2y67x8').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-zxoz2y67x8', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-9g8obxax51').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-9g8obxax51', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-n5wjtl6nzxa').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-n5wjtl6nzxa', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-w6ubsc3uldm').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-w6ubsc3uldm', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-eg85z7vza4t').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-eg85z7vza4t', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-avx7oagtlyc').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-avx7oagtlyc', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-lj1z9nus92a').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-lj1z9nus92a', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-0oqmf4syfpcb').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-0oqmf4syfpcb', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-cepxkiixbt').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-cepxkiixbt', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-l1vjdd5512').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-l1vjdd5512', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-cjxhqcfkwzk').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-cjxhqcfkwzk', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-to5jl420xh').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-to5jl420xh', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-09uk6k10d5uf').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-09uk6k10d5uf', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-1gcuavjmewn').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-1gcuavjmewn', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-jiz2740mo7').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-jiz2740mo7', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ane44c4tqz').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ane44c4tqz', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-h6w8bbaewnf').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-h6w8bbaewnf', settings: {"animation":false},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-vzdgjj2ewu"]=  window.__ectimmers["ecom-vzdgjj2ewu"] || {};
var $,E,A,j,P,T;let t=this.$el;if(!t)return;let e=this.isLive;const i=($=this.settings.disable_auto_close)!=null?$:!1,s=(E=this.settings.disable_auto_close__tablet)!=null?E:!1,o=(A=this.settings.disable_auto_close__mobile)!=null?A:!1,n=(j=this.settings.scroll_on_mobile)!=null?j:!1,r=(P=this.settings.disable_effect)!=null?P:!1,a=(T=this.settings.close_all)!=null?T:!1,l=t.querySelector(":scope > .core__group--wrapper > .core__group--items"),c=l?l.querySelectorAll(":scope > .ecom-accordion__item"):[],d=Array.from(c).map(I=>I.querySelector(":scope > .ecom-accordion__title")).filter(Boolean);function p(I){const D=I.getBoundingClientRect();return D.top>=0&&D.left>=0&&D.bottom<=(window.innerHeight||document.documentElement.clientHeight)&&D.right<=(window.innerWidth||document.documentElement.clientWidth)}function m(){return window.EComposer.TEMPLATE_ID?window.screen.width:window.innerWidth}function _(I){return o&&I<768||s&&I>767&&I<1025||i&&I>1024}function b(I){if(!I)return;const D=I.style.transition;I.style.transition="none",I.style.height="auto";const R=I.scrollHeight;I.style.height="0px",I.offsetHeight,I.style.transition=D,requestAnimationFrame(()=>{const H=r?"auto":e?R+"px":"auto";I.style.height=H})}function y(I){I.classList.remove("ecom-item-active");const D=I.querySelector(":scope > .ecom-accordion__body");D&&(r||(D.style.height=D.scrollHeight+"px",D.offsetHeight),requestAnimationFrame(()=>{D.style.height="0px"}))}function v(I){let D=0;if(I.offsetParent)do D+=I.offsetTop;while(I=I.offsetParent);return D}function w(I){const D=Math.max(0,I),R=window.pageYOffset||document.documentElement.scrollTop,H=D-R;if(H===0)return;const K=300;let V=null;function G(te){V||(V=te);const ne=Math.min((te-V)/K,1),Y=ne<.5?2*ne*ne:1-Math.pow(-2*ne+2,2)/2;window.scrollTo(0,R+H*Y),ne<1&&window.requestAnimationFrame(G)}window.requestAnimationFrame(G)}function z(I){w(v(I)-100)}function C(I,D=!1){I.forEach((R,H)=>{const K=R.parentNode,V=K.querySelector(":scope > .ecom-accordion__body");!r&&V&&V.classList.add("ecom-effect-accodion");const G=K.classList.contains("ecom-item-active");V&&!a&&(D&&H===0||G)&&requestAnimationFrame(()=>{V.style.height=V.scrollHeight+"px"}),R.onclick=function(te){var pe,_e;if(te.preventDefault(),!e){window.dispatchEvent(new window.Event("renderScroll"));return}const ne=m(),Y=this.parentNode,he=Y.parentNode,ce=he.querySelectorAll(":scope > .ecom-accordion__item"),ue=Array.from(ce).map(we=>we.querySelector(":scope > .ecom-accordion__title")).filter(Boolean),J=Y.querySelector(":scope > .ecom-accordion__body");Y.classList&&Y.classList.remove("ecom-item-group-init");const U=this.classList.contains("ecom-item-active"),X=_(ne);if(U)X?(this.classList.remove("ecom-item-active"),Y.classList.remove("ecom-item-active"),y(Y)):(ce.forEach(y),ue.forEach(we=>we.classList.remove("ecom-item-active")));else{X||(ce.forEach(y),ue.forEach(Ae=>Ae.classList.remove("ecom-item-active"))),R.classList.add("ecom-item-active"),Y.classList.add("ecom-item-active");let we=Y.closest(".ecom-accordion__body");for(;we;)we.style.height="auto",we=(_e=(pe=we.parentElement)==null?void 0:pe.closest)==null?void 0:_e.call(pe,".ecom-accordion__body");!r&&J&&J.classList.add("ecom-effect-accodion"),b(J)}window.dispatchEvent(new window.Event("renderScroll"));const ee=this,ge=n||ne>1024;function Q(){window.dispatchEvent(new window.Event("renderScroll")),ge&&!p(ee)&&z(ee)}if(ge&&!r){let we;const Ae=function(Te){Te.propertyName==="height"&&(clearTimeout(we),we=setTimeout(()=>{he.removeEventListener("transitionend",Ae),Q()},50))};he.addEventListener("transitionend",Ae),setTimeout(()=>{he.removeEventListener("transitionend",Ae),Q()},600)}else requestAnimationFrame(()=>{setTimeout(Q,100)})}})}C(d,!0),a||requestAnimationFrame(()=>{const I=t.querySelector(".ecom-item-group-init");I&&I.classList.remove("ecom-item-group-init")});function S(){const I=window.location.hash;if(I){const D=t.querySelector(`[data-target="${I}"]`);if(D){D.click(),D.dispatchEvent(new MouseEvent("mouseover",{bubbles:!0,cancelable:!0,view:window}));const K=D.getBoundingClientRect().top+window.pageYOffset-window.innerHeight/2;w(K)}}}requestAnimationFrame(()=>{setTimeout(S,100)}),window.addEventListener("resize",()=>C(d)),window.addEventListener("hashchange",S,!1)

                    });
                    
                        document.querySelectorAll('.ecom-vzdgjj2ewu').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-vzdgjj2ewu', settings: {"disable_auto_close":false,"disable_auto_close__tablet":true,"disable_effect":false,"close_all":true},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-jakrvika1ls"]=  window.__ectimmers["ecom-jakrvika1ls"] || {};
const t=function(r){if(window.EComModal)return r();if(window.EComposer&&typeof window.EComposer.loadVendor=="function"){window.EComposer.loadVendor("modal_js").then(function(){window.EComModal&&r()});return}let a=0;const l= window.__ectimmers["ecom-jakrvika1ls"]["1l4hxis4f"] = setInterval(function(){window.EComModal?(clearInterval(l),r()):++a>=300&&clearInterval(l)},50)};if(this.settings.link==="lightbox"&&this.settings.lightbox==="yes"&&this.$el){var e=this.$el.querySelector("[ecom-modal]"),i=this.id;t(function(){new window.EComModal(e,{cssClass:["ecom-container-lightbox-"+i]})})}let s=this.$el;if(!s)return;function o(r){const a=r.getBoundingClientRect();return a.top>=0&&a.left>=0&&a.bottom-r.offsetHeight/2<=(window.innerHeight||document.documentElement.clientHeight)&&a.right<=(window.innerWidth||document.documentElement.clientWidth)}function n(){let r=s.querySelector(".ecom-element.ecom-base-image"),a=s.closest(".core__row--columns");r&&(o(r)?(r.classList.add("image-highlight"),a.setAttribute("style","z-index: unset")):(r.classList.remove("image-highlight"),a.setAttribute("style","z-index: 1")))}this.settings.highligh_on_viewport&&window.addEventListener("scroll",function(){n()})

                    });
                    
                        document.querySelectorAll('.ecom-jakrvika1ls').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-jakrvika1ls', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ka403r11ter').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ka403r11ter', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ox7sc9hcaj').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ox7sc9hcaj', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-94yhrjd1jz').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-94yhrjd1jz', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-zl5nscl0ucr').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-zl5nscl0ucr', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-abtcwx9hl8t').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-abtcwx9hl8t', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-6u99vhy08bc').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-6u99vhy08bc', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-5apm26dbyt2').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-5apm26dbyt2', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-sjxntg0xran').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-sjxntg0xran', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-nrjewaz3nx9').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-nrjewaz3nx9', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-jc8k81znd2o').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-jc8k81znd2o', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-o8g1qmsz8pf').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-o8g1qmsz8pf', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-x66oaji3c4').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-x66oaji3c4', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ewg3us4n1bn').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ewg3us4n1bn', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    

                })();
            
;try{
 
} catch(error){console.error(error);}